import React, { Component } from 'react';
import PropTypes from 'prop-types';


class SearchType extends Component {
    render() {
        const formItemClass = `form-item${(this.props.isSelected) ? ' selected' : ''}`
        const wrapperDivId = `edit-ir-search-pacer-type-set-court-type-search${this.props.name}-wrapper`
        const labelFor = `edit-ir-search-pacer-type-set-court-type-search${this.props.name}`
        const inputId = `edit-ir-search-pacer-type-set-court-type-search${this.props.name}`

        return (
            <div
                onClick={this.props.changeSearchType.bind(this, this.props.name)}
                className={formItemClass} id={wrapperDivId}>
                <label className="option" htmlFor={labelFor}>
                    <input
                        type="radio"
                        id={inputId}
                        name={this.props.formName}
                        checked={this.props.isSelected}
                        onChange={() => null}
                        className="form-radio"/> {this.props.name}
                </label>
            </div>
        )
    }
}

SearchType.defaultProps = {
  formName: 'pacerSearch',
};

SearchType.propTypes = {
  formName: PropTypes.string,
};

export default SearchType



/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/searchType/SearchType.js
 **/